﻿import { ISearchSuggestion, IUser } from "@/interfaces";

export const mergeUsers = (
  existingUsers: IUser[],
  selectedSuggestions: string[],
  suggestedUsers?: ISearchSuggestion<IUser>[]
): IUser[] => {
  const filteredExistingUsers = existingUsers.filter(({ id }) =>
    selectedSuggestions.includes(id)
  );

  if (!suggestedUsers) return filteredExistingUsers;

  let newUsers: IUser[] = [];

  selectedSuggestions.forEach((userId) => {
    const newUser: IUser | undefined = suggestedUsers.find(
      ({ document: { id } }) => id === userId
    )?.document;

    if (!newUser) return;

    newUsers.push(newUser);
  });

  newUsers = newUsers.filter(
    (newUser) => !!newUser && !existingUsers.some(({ id }) => id === newUser.id)
  );

  return [...filteredExistingUsers, ...newUsers];
};
